module.exports = __webpack_public_path__ + "img/4736e855925779ef17f73ef719a524fb.woff";